<template>
  <div class="setmeal">
    <joymew-header></joymew-header>
    <div class="banner">
      <div class="banner-title">2024嗨喵大放价</div>
      <img src="@/assets/setMeal/banner-solgen.png" alt="嗨喵悦动,嗨喵互动,嗨喵优惠套餐">
      <div class="banner-tip">优惠套餐任你挑选</div>
      <div class="banner-time" style="background: linear-gradient(270deg,rgba(255,126,142,0.00) 0%, #ff7e8e 50%, rgba(255,126,142,0.00) 100%);">
        活动时间：2024.09.01——2024.12.31
      </div>
    </div>
    <div class="meals">
      <div class="meal-item" v-for="meal in mealList" :key="meal.meal_title">
        <div class="meal-banner">
          <img :src="meal.src" alt="嗨喵悦动,嗨喵互动,嗨喵大放价">
          <div class="meal-banner-label"></div>
        </div>
        <div class="meal-title">{{ meal.meal_title }}</div>
        <div class="meal-content">{{ meal.meal_content }}</div>
        <div class="meal-labels">
          <div class="meal-label" v-for="label in meal.meal_label" :key="label.value">{{ label.name }}</div>
        </div>
        <div class="meal-footer">
          <div class="meal-price">
            <div class="now-price">￥<span>{{meal.meal_now_dic}}</span>/场</div>
            <div class="org-price">{{ `原价￥${meal.meal_org_price}/场` }}</div>
          </div>
          <div @click="handleBuy" class="meal-buy">立即抢购</div>
        </div>
      </div>
    </div>
    <div class="em">
      <img class="em-banner" src="@/assets/setMeal/em-banner.png" alt="嗨喵悦动,嗨喵互动,嗨喵婚礼现场">
      <div class="em-items">
        <div class="em-item">
          <img src="../assets/setMeal/em1.png" alt="嗨喵悦动,嗨喵互动,嗨喵婚礼现场">
          <span class="em-label">2021年杭州婚礼现场</span>
        </div>
        <div class="em-item">
          <img src="../assets/setMeal/em2.png" alt="嗨喵悦动,嗨喵互动,嗨喵婚礼现场">
          <span class="em-label">2022嗨喵上海婚礼现场</span>
        </div>
        <div class="em-item">
          <img src="../assets/setMeal/em3.png" alt="嗨喵悦动,嗨喵互动,嗨喵婚礼现场">
          <span class="em-label">2023宁波婚礼现场</span>
        </div>
      </div>
    </div>
    <div class="service">
      <div class="service-banner">专业服务</div>
      <div class="service-items">
        <div class="service-item"><img src="@/assets/setMeal/service1.png" alt="嗨喵悦动,嗨喵互动,嗨喵服务"></div>
        <div class="service-item"><img src="@/assets/setMeal/service2.png" alt="嗨喵悦动,嗨喵互动,嗨喵服务"></div>
        <div class="service-item"><img src="@/assets/setMeal/service3.png" alt="嗨喵悦动,嗨喵互动,嗨喵服务"></div>
      </div>
    </div>
    <my-footer></my-footer>
    <div @click="showQrcode = false" v-show="showQrcode" class="qrcode-popup">
      <div @click.stop class="content">
        <img src="@/assets/image/qrcode.png" alt="嗨喵悦动,嗨喵互动,客服微信">
        <span>添加客服微信，领取优惠</span>
      </div>
    </div>
  </div>
</template>
<script>
import joymewHeader from '@/components/layout/joymewHeader.vue';
import myFooter from '@/components/myFooter.vue';

export default {
  name: 'setmeal',
  components: {
    joymewHeader,
    myFooter,
  },
  methods: {
    handleBuy() {
      this.showQrcode = true;
    },
  },
  mounted() {
  },
  data() {
    return {
      showQrcode: false,
      mealList: [
        {
          meal_title: '红包套餐',
          meal_content: '婚礼大屏红包雨，新颖又惊喜',
          src: 'https://www.hudongmiao.com/img/shakeRedEnvelopes.c2f9093a.gif',
          meal_label: [
            {
              name: '摇红包',
              value: '1',
            },
            {
              name: '点红包',
              value: '2',
            },
            {
              name: '红包墙',
              value: '3',
            },
            {
              name: '开宝箱',
              value: '4',
            },
          ],
          meal_org_price: '488',
          meal_now_dic: '288',
        },
        {
          meal_title: '抽奖套餐',
          meal_content: '炫酷抽奖，高端科技感',
          src: 'https://www.hudongmiao.com/img/giantScreenLottery.12f96f7b.gif',
          meal_label: [
            {
              name: '3D抽奖',
              value: '5',
            },
            {
              name: '巨幕抽奖',
              value: '6',
            },
            {
              name: '图片抽奖',
              value: '7',
            },
            {
              name: '名单抽奖',
              value: '8',
            },
          ],
          meal_org_price: '488',
          meal_now_dic: '288',
        },
        {
          meal_title: '游戏套餐',
          meal_content: '婚礼玩游戏，互动更有趣',
          src: 'https://www.hudongmiao.com/img/guessMovie.418f5b16.gif',
          meal_label: [
            {
              name: '扭一扭',
              value: '9',
            },
            {
              name: '转一转',
              value: '10',
            },
            {
              name: '猜成语',
              value: '11',
            },
            {
              name: '猜明星',
              value: '12',
            },
          ],
          meal_org_price: '488',
          meal_now_dic: '288',
        },
        {
          meal_title: '经典套餐',
          meal_content: '经典功能，创造十足仪式感',
          src: 'https://www.hudongmiao.com/hm-customer/static/img/giftAllFree1.a73aef91.gif',
          meal_label: [
            {
              name: '3D签到',
              value: '13',
            },
            {
              name: '祝福包场',
              value: '14',
            },
            {
              name: '红包墙',
              value: '3',
            },
            {
              name: '抽奖',
              value: '15',
            },
          ],
          meal_org_price: '688',
          meal_now_dic: '388',
        },
        {
          meal_title: '3D签到套餐',
          meal_content: '自定义签到，酷炫科技感',
          src: 'https://www.hudongmiao.com/img/dargonFlyInSky.a39fc9f8.gif',
          meal_label: [
            {
              name: '摇红包',
              value: '16',
            },
            {
              name: '点红包',
              value: '13',
            },
            {
              name: '红包墙',
              value: '17',
            },
            {
              name: '开宝箱',
              value: '4',
            },
          ],
          meal_org_price: '688',
          meal_now_dic: '388',
        },
        {
          meal_title: '尊享套餐',
          meal_content: '专属客服服务，涵盖全部功能',
          src: 'https://www.hudongmiao.com/hm-customer/static/img/giftAllFree2.a6ad565d.gif',
          meal_label: [
            {
              name: '摇红包',
              value: '18',
            },
            {
              name: '点红包',
              value: '19',
            },
            {
              name: '红包墙',
              value: '20',
            },
            {
              name: '开红包',
              value: '21',
            },
          ],
          meal_org_price: '1288',
          meal_now_dic: '888',
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
// ::v-deep .header {
//   width: 100%;

//   box-sizing: border-box;
//   // position: absolute;
//   position: absolute;
//   background-color: transparent ;
//   top: 0;
//   z-index: 10;
//   // .el-menu-item .weddingItem {
//   //   &:hover {
//   //     color: #FFCC4F !important;
//   //   }
//   // }
//   .el-submenu__title:hover {
//     .weddingItem,.headerStyle {
//       color: #FFCC4F !important;;
//     }
//     .el-submenu__icon-arrow {
//       color: #FFCC4F !important;
//     }
//   }
//   .headerStyle:hover {
//     color
//   }
//   .middle ul {
//     border: 0 !important;

//     .weddingItem {
//       color: white;
//       font-weight: normal;
//       transition: color .3s;
//       // &:hover {
//       //   color: #FFCC4F !important;

//       // }

//     }
//     .headerStyle {
//       color: white;
//       font-weight: normal;
//       transition: color .3s;
//       // &:hover {
//       //   color: #FFCC4F !important;

//       // }

//     }
//     .el-submenu__icon-arrow {
//       color: white !important;
//     }

//   }
//   .right {
//     .login {
//       color: white !important;
//     }

//     .register {
//       color: #FFCC4F !important;
//       background: white !important;
//     }

//   }
// }
.qrcode-popup {
  // backdrop-filter: blur(10px);
  display: flex;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  // background-color: red;
  z-index: 100;
  justify-content: center;
  align-items: center;

  .content {
    transform: scale(.8);
    filter: drop-shadow(0 0 10px rgba(0,0,0,0.25));
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 42.67px;
    padding: 44px;
    background-color: #fff;
    border-radius: 16px;
    img {
      width: 577.33px;
      height: 574.67px;

    }
  }
}
.setmeal {
  img {
    -webkit-user-drag: none;
  }
  .banner {
    width: 100%;
    height: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url('~@/assets/setMeal/banner-bg.png');
    background-size: 100% 100%;
    box-shadow: 0 -61px 100px #F2B0C0 inset;
    position: relative;
    z-index: 2;

    .banner-title {
      width: 659px;
      height: 107px;
      margin-top: 120px;
      margin-bottom: 17px;
      background-image: url('../assets/setMeal/banner-title.png');
      background-size: 100%;
      color: #FFFFFF;
      font-size: 62px;
      font-weight: bold;
      line-height: 107px;
      text-align: center;
    }

    img {
      width: 1355px;
      height: 159px;
      margin-bottom: 32px;
    }

    .banner-tip {
      height: 60px;
      margin-bottom: 43px;
      color: #FF6174;
      font-size: 43px;
      text-align: center;
      line-height: 60px;
    }

    .banner-time {
      width: 992px;
      height: 91px;
      font-size: 42.67px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
    }
  }

  .meals {
    width: 100%;
    margin-top: -30px;
    padding: 0 387px 85px 387px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(3, min-content);
    justify-content: center;
    row-gap: 53.33px;
    column-gap: 53.33px;
    // justify-content: space-between;
    // align-items: center;
    // flex-wrap: wrap;
    background-color: #F2B0C0;
    box-shadow: 0 -61px 100px #F2B0C0;
    z-index: -1;

    .meal-item {
      width: 347px;
      height: 421px;
      margin-top: 52px;
      padding: 16px;
      box-sizing: border-box;
      background-color: #FFFFFF;
      border: 3px solid #FFE596;
      z-index: 3;

      &:nth-of-type(-n + 3) {
        margin-top: 0;
      }

      .meal-banner {
        width: 100%;
        height: 181px;
        margin-bottom: 21px;
        background-color: #FFD0D0;
        position: relative;

        .meal-banner-label {
          width: 64px;
          height: 23px;
          background-image: url('../assets/setMeal/meal-banner-label.png');
          background-size: 100% 100%;
          position: absolute;
          bottom: 0;
          right: 15px;
        }
      }

      .meal-title {
        margin-bottom: 5px;
        font-size: 27px;
        font-weight: bold;
      }

      .meal-content {
        margin-bottom: 13px;
        font-size: 19px;
      }

      .meal-labels {
        width: 100%;
        height: 24px;
        margin-bottom: 13px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .meal-label {
          white-space: nowrap;
          // width: 56px;
          padding: 1px;
          height: 100%;
          margin-right: 11px;
          background-color: #FFF1F2;
          border: 1px solid #FFCACE;
          border-radius: 3px;
          color: #FF2737;
          text-align: center;
          line-height: 24px;

          &:last-of-type {
            margin-right: 0;
          }
        }
      }

      .meal-footer {
        width: 100%;
        height: 66px;
        padding: 0 5px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .meal-price {
          .now-price {
            color: #FF2B3A;
            font-size: 19px;
            span {
              font-weight: bold;
              font-size: 32px;
            }
          }
          .org-price {
            font-size: 16px;
            color: #999999;
          }
        }

        .meal-buy {
          width: 137px;
          height: 51px;
          background: linear-gradient(to bottom, #FF9E9D, #FF5F72);
          border-radius: 37px;
          color: #FFFFFF;
          font-size: 21px;
          line-height: 51px;
          text-align: center;
          cursor: pointer;
          transition: all .5s;
          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }
  }
  .em {
    width: 100%;
    padding: 85px 160px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #FFE2E6;
    .em-banner {
      width: 361px;
      height: 133px;
      margin-bottom: 53px;
    }
    .em-items {
      width: 100%;
      height: 387px;
      display: flex;
      justify-content: center;
      align-items: center;
      .em-item {
        margin: 0 18px;
        width: 509px;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #FFFFFF;
        cursor: default;
        img {
          width: 100%;
          height: 287px;
          margin: 0;
        }
        .em-label {
          width: 100%;
          height: 100px;
          color: #333333;
          font-size: 27px;
          text-align: center;
          line-height: 100px;
        }
      }
    }
  }
  .service {
    width: 100%;
    padding: 85px 160px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F2B0C0;
    .service-banner {
      width: 351px;
      height: 123px;
      margin-bottom: 64px;
      box-sizing: border-box;
      background: linear-gradient(to right, #FFA29B, #FE6767);
      border: 3px solid #FFFFFF;
      border-radius: 76px;
      color: #FFFFFF;
      font-size: 53px;
      font-weight: bold;
      line-height: 123px;
      text-align: center;
      cursor: none;
    }
    .service-items {
      width: 100%;
      height: 330px;
      display: flex;
      // justify-content: space-between;
      justify-content: center;

      align-items: center;
      .service-item {
        margin: 0 18px;
        width: 509px;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .others {
    width: 100%;
    padding: 43px 200px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #FAF9F8;
    dt {
      margin-bottom: 13px;
      color: #333333;
      font-size: 24px;
      font-weight: bold;
      line-height: 35px;
      cursor: default;
    }
    dd {
      font-size: 20px;
      margin-bottom: 9px;
      cursor: pointer;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
  .footer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #FFFFFF;
    .footer-logo {
      width: 374px;
      height: 185px;
      margin-top: 53px;
      margin-bottom: 54px;
    }
    .cmp-info {
      width: 100%;
      margin-bottom: 25px;
      color: #FFCC4F;
      font-size: 20px;
      text-align: center;
    }
    .other-info {
      width: 100%;
      margin-bottom: 79px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: default;
      img {
        width: 30px;
        height: 30px;
        margin-right: 8px;
      }
      span {
        font-size: 20px;
        &:first-of-type {
          margin-right: 48px;
        }
      }
    }
  }
}</style>
